import script from "./TransferModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferModal.vue?vue&type=script&setup=true&lang=js"

import "./TransferModal.vue?vue&type=style&index=0&id=3ef5fe7c&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef5fe7c"]])

export default __exports__